import React, {useState} from 'react';
import './BoxVideo.css';

function BoxVideo({title, description, embed, type = "", bColor}) {
    const [showType, setShowType] = useState(true);

    function onVideoStateChange(event) {
        switch(event.data) {
          case 0:
            setShowType(false)
            // record('video ended');
            break;
          case 1:
            setShowType(false);
            // record('video playing from '+player.getCurrentTime());
            break;
          case 2:
            setShowType(true);
            // record('video paused at '+player.getCurrentTime());
        }
    }

    return ( 
        <div className="box_video_components">
            <div className="box_video">
                <iframe
                    src={`https://www.youtube.com/embed/${embed}`}
                    // src='https://www.youtube.com/embed/Wlq-T2cUO2w'
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    title="Embedded youtube"
                    // onChange={(e)=>onVideoStateChange(e)}
                />
            </div>
            <div className="box_video_info">
                <span className="box_video_title">
                    {title}
                </span>
                <span className="box_video_description">
                    {description}
                </span>
                {
                    type !== "" && showType && 
                    <span className='box_video_span_info' style={{backgroundColor: bColor}}>
                        {
                            type
                        }
                    </span>
                }
            </div>
        </div>
    );
}

export default BoxVideo;